import PropTypes from 'prop-types';
import {memo} from 'preact/compat';
import {useMediaQuery} from '@util/media-queries';
import breakpoints from '@config/breakpoints';
import LocationCard from '@components/account/find-a-dentist/LocationCard';
import {Search, Show} from '@ultradent/components';
import useProductOfferingLocations from '@containers/FindADentistOptIn/useProductOfferingLocations';
import ToggleAllLocationsButton from '@components/account/find-a-dentist/ToggleAllLocationsButton';
import LocationsListHeader from '@components/account/find-a-dentist/LocationsListHeader';
import OptInReminderOption from '@components/account/find-a-dentist/OptInReminderOption';

export const ProductOfferingLocations = memo( ( {list, optInProductReorderReminder, isLgpAdmin}, context ) => {

    const {
        allLocationsOn,
        productOfferingLocations,
        onOptInProductReorderReminder,
        onUpdateProductOffering,
        onUpdateDisplayOnMap,
        onToggleAllLocations
    } = useProductOfferingLocations( {productOfferingLocations: list} );

    const isHandheldDevice = useMediaQuery( `(min-width: 0px) and (max-width: ${breakpoints.screenLarge - 1}px)` );

    if ( productOfferingLocations.length >= 30 ) {
        return (
            <Search
                initialQuery={''}
                minQueryLength={2}
                resultLimit={25}
                showPagination={true}
                showDefaultResults={true}
                showNoResults={true}
                showAllResults={true}
                alwaysShowResults={true}
                itemProps={{
                    onUpdateProductOffering,
                    onUpdateDisplayOnMap
                }}
                queryGroup={[
                    {
                        list: productOfferingLocations,
                        renderer: LocationCard,
                        queryProps: ['address'],
                        virtualized: true,
                        itemSize: isHandheldDevice ? 616 : 275
                    }
                ]}
            >
                {() =>
                    <div class="max-w-5xl mx-auto pad-content contain-content">
                        <div class="md:flex items-end">
                            <LocationsListHeader/>
                            <div className="flex-1">
                                <Search.Input/>
                            </div>
                        </div>
                        <div className="md:flex justify-between items-center flex-row-reverse">
                            <ToggleAllLocationsButton isAllOn={allLocationsOn} onClick={onToggleAllLocations}/>
                            <Show when={context.user?.salesChannel === 'dom' || isLgpAdmin}>
                                <OptInReminderOption optIn={optInProductReorderReminder}
                                                     onChange={onOptInProductReorderReminder}/>
                            </Show>
                        </div>
                        <Search.Results
                            noResultsClass="px-8 py-16 my-4 subheading-lg text-center border-2 border-dashed border-grey-lightest rounded">
                            {( results ) => results}
                        </Search.Results>
                    </div>
                }
            </Search>
        );
    }

    return (
        <div class="max-w-5xl mx-auto pad-content contain-content">
            <LocationsListHeader/>
            <div className="md:flex justify-between items-center flex-row-reverse">
                <ToggleAllLocationsButton isAllOn={allLocationsOn} onClick={onToggleAllLocations}/>
                <Show when={context.user?.salesChannel === 'dom' || isLgpAdmin}>
                    <OptInReminderOption optIn={optInProductReorderReminder}
                                         onChange={onOptInProductReorderReminder}/>
                </Show>
            </div>
            {productOfferingLocations.map( ( {address, productOfferings, displayOnMap} ) => {
                return <LocationCard
                    key={address.id}
                    address={address}
                    productOfferings={productOfferings}
                    displayOnMap={displayOnMap}
                    onUpdateProductOffering={onUpdateProductOffering}
                    onUpdateDisplayOnMap={onUpdateDisplayOnMap}/>
            } )}
        </div>
    );
} );

ProductOfferingLocations.propTypes = {
    list: PropTypes.array,
    optInProductReorderReminder: PropTypes.bool
};
